import React, { useState } from "react";
import "../../Stylesheets/OurVirtualTour/OurVirtualTour.scss";
import pauseplay from "../../assests/Images/pauseplaybtn.png";
import samplevideo from "../../assests/Videos/OurVirtualTour/sample-30s.mp4";
import realestate from "../../assests/Images/OurvirtualsTour/realestate.jpg";
import restaurants from "../../assests/Images/OurvirtualsTour/restaurants.jpg";
import showroom from "../../assests/Images/OurvirtualsTour/showroom.jpg";

import hospitals from "../../assests/Images/OurvirtualsTour/hospitals.jpg";
import hotels from "../../assests/Images/OurvirtualsTour/hotels.jpg";

import education from "../../assests/Images/OurvirtualsTour/education.jpg";
import automobile from "../../assests/Images/OurvirtualsTour/automobile.jpg";
import itpark from "../../assests/Images/OurvirtualsTour/itpark.jpg";

const OurVirtualTour = () => {
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="virtualtour-main-wrapper">
      <div className="virtualtour-inner-wrapper">
        <div className="vitraultour-heading">
          <button>
            <span className="our-threesixty">Industries</span> We Operate
          </button>
        </div>

        <div className="video-main-container">
          <div className="video-inner container">
            <div class="row row-cols-1 row-cols-md-3 g-4">
              {/* Popup */}

              {showPopup && (
                <div className="popup" onClick={closePopup}>
                  <div
                    className="popup-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="close" onClick={closePopup}>
                      &times;
                    </span>
                    <p></p>
                    {/* <p>Video Popup</p> */}
                    <video
                      src={samplevideo}
                      className="video-wrap"
                      controls
                      width="600"
                      height="350"
                    ></video>
                  </div>
                </div>
              )}

              {/* column 1 */}
              <div class="col">
                <div class="card">
                  <img src={realestate}></img>
                  <div class="card-body">
                    <p class="card-text">Real Estate</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>

                <div class="card">
                  <img src={restaurants}></img>
                  <div class="card-body">
                    <p class="card-text">Restaurants & Cafe</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>

                <div class="card">
                  <img src={showroom}></img>
                  <div class="card-body">
                    <p class="card-text">Retail Showrooms</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>
              </div>

              {/* column 2 */}
              <div class="col">
                <div class="card">
                  <img className="hospitals_img" src={hospitals}></img>
                  <div class="card-body">
                    <p class="card-text">Hospitals</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>

                <div class="card">
                  <img className="resorts_hotel" src={hotels}></img>
                  <div class="card-body">
                    <p class="card-text">Hotels & Resorts</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>
              </div>

              {/* column 3 */}
              <div class="col">
                <div class="card">
                  <img src={education}></img>
                  <div class="card-body">
                    <p class="card-text">Education</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>

                <div class="card">
                  <img src={automobile}></img>
                  <div class="card-body">
                    <p class="card-text">Automobile (Car)</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>

                <div class="card">
                  <img className="it_park_img" src={itpark}></img>
                  <div class="card-body">
                    <p class="card-text">IT Park</p>

                    <button className="pause-play-btn" onClick={openPopup}>
                      {/* <img src={pauseplay} className="pause-play-img"></img> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurVirtualTour;
